import React from "react";
import { Container } from "./components/Container";
import "./App.scss";

function App() {
  return (
    <div className="infinit-scroll">
      <Container />
    </div>
  );
}

export default App;
